import {
  HelpIcon,
  Panel,
  RadioButton,
  RADIOBUTTON_LABEL_FW_STANDARD,
  SPACING_16,
  SpacingVertical,
  Title,
  TITLE_VARIANT_M,
  TooltipUtils
} from 'mailup-web-components'
import {
  taskPanelFrequencyState,
  taskState
} from 'Pages/Task/recoil/state/task'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilState, useSetRecoilState } from 'recoil'

const PanelConditios = () => {
  const intl = useIntl()

  const [task, setTask] = useRecoilState(taskState)
  const setTaskPanelFrequency = useSetRecoilState(taskPanelFrequencyState)

  useEffect(() => {
    TooltipUtils.rebuild()
  }, [])

  return (
    <Panel>
      <Title variant={TITLE_VARIANT_M}>
        {intl.formatMessage({ id: 'Load.Task.FrequencyOnConflictTitle' })}
        <HelpIcon
          text={intl.formatMessage({
            id: 'Load.Task.FrequencyOnConflictTooltip'
          })}
        />
      </Title>

      <SpacingVertical />

      <RadioButton
        data-mu-test='task-4-btn-as-soon-as-possible-true'
        value={'true'}
        checked={task.Frequency.AsSoonAsPossible}
        label={intl.formatMessage({
          id: 'Load.Task.FrequencyOnConflictActivateAsap'
        })}
        labelVariant={RADIOBUTTON_LABEL_FW_STANDARD}
        onChange={() => {
          setTask((prev) => ({
            ...prev,
            Frequency: {
              ...prev.Frequency,
              AsSoonAsPossible: true
            }
          }))
          setTaskPanelFrequency((prev) => ({
            ...prev,
            isDirty: true
          }))
        }}
      />
      <SpacingVertical variant={SPACING_16} />
      <RadioButton
        data-mu-test='task-4-btn-as-soon-as-possible-false'
        value={'false'}
        checked={!task.Frequency.AsSoonAsPossible}
        label={intl.formatMessage({
          id: 'Load.Task.FrequencyOnConflictDoNotActivate'
        })}
        labelVariant={RADIOBUTTON_LABEL_FW_STANDARD}
        onChange={() => {
          setTask((prev) => ({
            ...prev,
            Frequency: {
              ...prev.Frequency,
              AsSoonAsPossible: false
            }
          }))
          setTaskPanelFrequency((prev) => ({
            ...prev,
            isDirty: true
          }))
        }}
      />
    </Panel>
  )
}

export default PanelConditios
